import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './ui/CtaButton';
import { audience, CHECKOUT_URL } from '../data/content';
export function AudienceSection() {
  return <section aria-labelledby="para-vos" className="border-y border-line bg-canvasAlt" data-id="element-18" data-mp="wznwtytguiur">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-14 text-center" data-id="element-19" data-mp="3vhl63wxzdjiz">
        <Reveal data-id="element-20" data-mp="3vfgtmqm0nc73">
          <SectionHeading id="para-vos" title="Es para vos si…" data-id="element-21" data-mp="4aqs6yi6gkkh" />
        </Reveal>

        <ul className="mx-auto mt-8 grid max-w-4xl gap-3 sm:grid-cols-2" data-id="element-22" data-mp="48nwpyy99z8d">
          {audience.map((item, i) => <Reveal key={item} as="li" delay={i * 0.03} className="flex items-center justify-center gap-3 rounded-xl border border-line bg-surface px-5 py-4 text-sm md:text-base font-medium text-ink" data-id="element-23" data-mp="e0juf8wfjnc2" data-mpi={i}>
              <CheckIcon size={16} className="flex-shrink-0 text-cta" strokeWidth={3} data-id="element-24" data-mp="3hntywv7q2bqf" />
              <span data-id="element-25" data-mp="zbg3jl342su6">{item}</span>
            </Reveal>)}
        </ul>

        <Reveal delay={0.1} className="mt-8 flex justify-center" data-id="element-26" data-mp="ukr6zrckr5o6">
          <CtaButton href={CHECKOUT_URL} external size="lg" data-id="element-27" data-mp="uiwmuf94nhl5">
            Sí, quiero empezar
          </CtaButton>
        </Reveal>
      </div>
    </section>;
}